import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "src/store/features/auth/axiosCSRF";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";



// State 정의 
export interface iCreateAccountState{
    email: string;
    name : string;
    company: string;
    password:string;
    position:string;
    department:string;
    isLoading: boolean;
    response : any;
}

const initialState : iCreateAccountState = {
    email : '',
    name:'',
    company: '',
    password : '',
    position : '',
    department : '',
    isLoading:false,
    response : [],
}

// 회원가입 API Post
export const postCreateAccountAPI = createAsyncThunk(
    'GET_CREATE_ACCOUNT',
    async (createAccount:{email:string, name:string, position:string, department:string, password:string,company:string, sid:string, token:string }, { rejectWithValue }) => {
        try {

          const djangoEndpoint = getDjangoEndpoint();
          const pathParam = '/auth/signup/complete/';       

          const response = await axiosInstance.post(
            `${djangoEndpoint}${pathParam}`,
            {
              email: createAccount.email,
              name: createAccount.name,
              position: createAccount.position,
              department: createAccount.department,
              password: createAccount.password,
              company : createAccount.company,
              sid: createAccount.sid,
              token: createAccount.token,
            },
            {
              withCredentials: true,
            }
          );
          return response.data;
        } catch (error) {
            console.error('회원가입 API 호출 에러:', error);
            return rejectWithValue(error.response ? error.response.data : error.message);
          }
        }
    );

// 비동기적 상태관리 
export const createAccountSlice = createSlice({
    name: 'create_account',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
           .addCase(postCreateAccountAPI.pending, (state) => {
                state.isLoading = true; 
            })
            .addCase(postCreateAccountAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.email = action?.payload.email || null;
                state.password = action?.payload.password || null;
                state.name = action?.payload.name || null;
                state.company = action?.payload?.company || null;
                state.position = action?.payload?.position || null;
                state.department = action?.payload?.department || null;
                state.response = action.payload || null;
            })
           .addCase(postCreateAccountAPI.rejected, (state, action) => {
                state.isLoading = false; 
            });
    }
});

export default createAccountSlice.reducer;
